export default "__VITE_ASSET__DdrRCgvp__"